import { State } from '../state';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { selectBpmnProcessState } from './bpmn-process-state.selector';
import { ProcessExecutionStatus } from '@ispm-shared/modules/bpmn';

const getProcessExecutionStatus = (state: State): any => state.processExecutionStatus;

export const selectProcessExecutionStatus: MemoizedSelector<
  object,
  ProcessExecutionStatus
  > = createSelector(selectBpmnProcessState, getProcessExecutionStatus);
